<template>
  <component
    :is="`h${level}`"
    class="text-gray-800"
  >
    <DsIcon
      v-if="icon"
      :name="icon.name"
      :size="icon.size"
      :variant="icon.variant"
      :class="icon.class"
    />
    {{ text }}
    <slot />
  </component>
</template>

<script setup lang="ts">

import type { IconVariant, IconSize } from '@demvsystems/design-components';
import { DsIcon } from '@demvsystems/design-components';

interface Props {
  text: string;
  level?: '1' | '2' | '3' | '4' | '5' | '6';
  icon?: {
    name: string,
    class: string,
    size?: IconSize,
    variant?: IconVariant;
  };
}

withDefaults(defineProps<Props>(), {
  level: '1',
  icon: undefined,
});
</script>
